import { useCompanyInfo } from '@src/utils/hooks/useCompanyInfo';
import { ClientHealth } from './ClientHealth';

export const Recap = () => {
  const { cid } = useCompanyInfo();
  return (
    <div className='client-config-recap'>
      <ClientHealth cid={cid} />
    </div>
  );
};
